import React, { useState, useEffect, useRef, useCallback  } from 'react';
import styles from '../tablesStyle/MovementSection.module.css';
import MovementModal from '../../customComponents/MovementModal';
import CustomSelect from '../../customComponents/CustomSelect';
import { API_URL } from '../../config/api';
import MovementSidePanel from "../tables/customComponentsTable/MovementSidePanel";
import { MoreVertical } from 'lucide-react';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
pdfMake.vfs = pdfFonts.vfs;


const MovementSection = () => {
  const token = localStorage.getItem("token");
  const [type, setType] = useState('');
  const [rows, setRows] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [storages, setStorages] = useState([]);
  const [fromStorage, setFromStorage] = useState(null);
  const [toStorage, setToStorage] = useState(null);
  const [selectedTransfer, setSelectedTransfer] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); 
  const menuRef = useRef(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  useEffect(() => {
    const fetchStorages = async () => {
      if (!token) return console.error("❌ Нет токена!");

      try {
        const res = await fetch(`${API_URL}/api/storages`, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        });
        const data = await res.json();
        if (data?.data) setStorages(data.data);
      } catch (err) {
        console.error("Ошибка загрузки складов:", err);
      }
    };
    fetchStorages();
  }, [token]);
  const fetchTransfers = useCallback(async () => {
    if (!token) return;

    try {
      let url = `${API_URL}/api/stock_changes?type=transfer`;
      if (fromStorage) url += `&source_storage_id=${fromStorage}`;
      if (toStorage) url += `&storage_id=${toStorage}`;

      const res = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (data?.data) setRows(data.data);
    } catch (err) {
      console.error("Ошибка загрузки перемещений:", err);
    }
  }, [fromStorage, toStorage, token]);

  useEffect(() => {
    fetchTransfers();
  }, [fetchTransfers]);

const updateStatus = async (id, status) => {
  try {
    const res = await fetch(`${API_URL}/api/stock_changes/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, 
      },
      body: JSON.stringify({ status }),
    });

    const data = await res.json();
    if (!res.ok) {
      console.error("Ошибка при обновлении статуса:", data);
      alert(`Ошибка (${res.status}): ${data.errors?.message || 'Неизвестная ошибка'}`);
      return;
    }

    await fetchTransfers(); 
    setOpenMenuId(null); 
  } catch (err) {
    console.error("Ошибка при обновлении статуса:", err);
  }
};

  const statusMap = {
    for_approval: "На согласовании",
    approved: "Подтверждено",
    cancelled: "Отклонено"
  };

  const handleDownloadXLSX = async (row) => {
  try {
      const itemsRes = await fetch(`${API_URL}/api/stock_changes/${row.id}/items`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });


      const itemsData = await itemsRes.json();

      const productsRes = await fetch(`${API_URL}/api/products`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
      const productsData = await productsRes.json();

      if (!itemsData?.data || !productsData?.data) return;

      const sourceStorage = getStorageName(row.source_storage_id);
      const destStorage = getStorageName(row.storage_id);

    const table = itemsData.data.map((item, idx) => {
      const product = productsData.data.find((p) => p.id === item.product_id);
      return [
        idx + 1,
        product?.ntin || "—",
        product?.name_ru || "Неизвестно",
        item.quantity,
        "шт",
        item.purchase_price,
      ];
    });

    const total = table.reduce(
      (acc, cur) => acc + parseFloat(cur[3]) * parseFloat(cur[5]),
      0
    );

    const sheetData = [
      [
        `Накладная на перемещение № ${row.name} от ${new Date(
          row.inserted_at
        ).toLocaleDateString()}`,
        "",
        "",
        "",
        "",
        "",
      ],
      [`Отправитель:`],
      [`Структурная единица:`],
      [`Склад: ${sourceStorage}`],
      [""],
      [`Получатель:`],
      [`Структурная единица:`],
      [`Склад: ${destStorage}`],
      [""],
      [""],
      ["№", "Штрих код", "Товар", "Количество", "Единица", "Сумма"],
      ...table,
      ["Итого:", "", "", "", "", total.toFixed(2)],
      [""],
      [""],
      ["Отпустил: ____________________", "", "", "", "", "подпись / расшифровка"],
      [""],
      ["Получил: ____________________", "", "", "", "", "подпись / расшифровка"],
    ];

    const ws = XLSX.utils.aoa_to_sheet(sheetData);

     ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } }, 
      { s: { r: 1, c: 0 }, e: { r: 1, c: 5 } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: 5 } },
      { s: { r: 3, c: 0 }, e: { r: 3, c: 5 } },
      { s: { r: 4, c: 0 }, e: { r: 4, c: 5 } },
      { s: { r: 5, c: 0 }, e: { r: 5, c: 5 } },
      { s: { r: 6, c: 0 }, e: { r: 6, c: 5 } },
      { s: { r: 7, c: 0 }, e: { r: 7, c: 5 } },

      { s: { r: 10 + table.length + 1, c: 0 }, e: { r: 10 + table.length + 1, c: 4 } },

      { s: { r: 13 + table.length + 1, c: 0 }, e: { r: 13 + table.length + 1, c: 4 } },

      { s: { r: 15 + table.length + 1, c: 0 }, e: { r: 15 + table.length + 1, c: 4 } },
    ];

    ws["A1"].s = {
      font: { bold: true, sz: 14 },
      alignment: { horizontal: "center" },
    };

    ws["A4"].s = { font: { bold: true } };
    ws["A8"].s = { font: { bold: true } };

    const tableStartRow = 11; 
    const tableEndRow = tableStartRow + table.length + 1; 
    const allCols = ["A", "B", "C", "D", "E", "F"];

    for (let r = tableStartRow; r <= tableEndRow; r++) {
      allCols.forEach((col) => {
        const cell = ws[`${col}${r}`];
        if (cell) {
          cell.s = {
            ...(cell.s || {}),
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
            alignment: { horizontal: "center", vertical: "center" },
          };
        }
      });
    }

    allCols.forEach((col) => {
      const cell = ws[`${col}${tableStartRow}`];
      if (cell) {
        cell.s = {
          ...(cell.s || {}),
          font: { bold: true },
        };
      }
    });

    ws[`A${tableEndRow}`].s = {
      font: { bold: true },
      alignment: { horizontal: "right" },
    };

    ws["!cols"] = [
      { wch: 5 }, 
      { wch: 15 }, 
      { wch: 30 }, 
      { wch: 12 },
      { wch: 10 },
      { wch: 15 }, 
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Накладная");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      `nakladnaya_${row.id}.xlsx`
    );
  } catch (err) {
    console.error("Ошибка при формировании XLSX:", err);
  }
};


  const handleDownloadPDF = async (row) => {
  try {
    const itemsRes = await fetch(`${API_URL}/api/stock_changes/${row.id}/items`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
    const itemsData = await itemsRes.json();

    const productsRes = await fetch(`${API_URL}/api/products`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    const productsData = await productsRes.json();

    if (!itemsData?.data || !productsData?.data) return;

    const sourceStorage = getStorageName(row.source_storage_id);
    const destStorage = getStorageName(row.storage_id);

    const merged = itemsData.data.map((item, idx) => {
      const product = productsData.data.find((p) => p.id === item.product_id);
      return [
        idx + 1,
        product?.ntin || "—",
        product?.name_ru || "Неизвестно",
        item.quantity + " ШТ",
        item.purchase_price,
      ];
    });

    const total = merged.reduce(
      (acc, cur) => acc + parseFloat(cur[4]) * parseFloat(cur[3]),
      0
    );

    const docDefinition = {
      content: [
        { text: `Накладная на перемещение № ${row.name}`, style: "header" },
        { text: `от ${new Date(row.inserted_at).toLocaleDateString()}\n\n` },

        { text: `Отправитель: ${sourceStorage}` },
        { text: `Получатель: ${destStorage}\n\n` },

        {
          table: {
            widths: ["auto", "*", "*", "auto", "auto"],
            body: [
              ["№", "Штрихкод", "Товар", "Количество", "Сумма"],
              ...merged,
            ],
          },
        },

        { text: `\nИтого: ${total.toFixed(2)}`, bold: true },

        { text: "\n\nОтпустил: ____________________", margin: [0, 20, 0, 0] },
        { text: "Получил: ____________________", margin: [300, -15, 0, 0] },
      ],
      styles: {
        header: { fontSize: 14, bold: true, margin: [0, 0, 0, 10] },
      },
      defaultStyle: {
        font: "Roboto",
      },
    };

    pdfMake.createPdf(docDefinition).download(`nakladnaya_${row.id}.pdf`);
  } catch (err) {
    console.error("Ошибка при формировании PDF:", err);
  }
};

  useEffect(() => {
  const fetchStorages = async () => {
    try {
      const cachedStorages = localStorage.getItem('storages');
      if (cachedStorages) {
        setStorages(JSON.parse(cachedStorages));
        return; 
      }

      const res = await fetch(`${API_URL}/api/storages`);
      const data = await res.json();

        if (data?.data) {
          setStorages(data.data);
          localStorage.setItem('storages', JSON.stringify(data.data));
        }
      } catch (error) {
        console.error('Ошибка загрузки складов:', error);
      }
    };

    fetchStorages();
  }, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenuId(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getStorageName = (id) => {
    const storage = storages.find((s) => s.id === id);
    return storage ? storage.name : `Склад ${id}`;
  };

  const handleModalSubmit = ({ from, to, comment }) => {
    console.log("Выбранные ID:", { from, to, comment });
    setIsModalOpen(false);
    setSelectedTransfer({ from, to });
  };


  const handleOpenMenu = (event, rowId) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    let top;
    if (spaceBelow < 150 && spaceAbove > spaceBelow) {
      top = rect.top + window.scrollY - 150; 
    } else {
      top = rect.bottom + window.scrollY;
    }

    setMenuPosition({
      top,
      left: rect.right + window.scrollX - 160, 
    });

    setOpenMenuId(rowId);
  };

  return (
    <div className={styles.container}>
      <button className={styles.addCustomers} onClick={() => setIsModalOpen(true)}>
        Создать
      </button>
      <div className={styles.filters}>
        <CustomSelect
          className={styles.filters__select}
          options={['Товар однотипный', 'Товар многотипный', 'Услуга', 'Составной товар']}
          value={type}
          onChange={setType}
          placeholder="Товар однотипный"
        />

        <input type="date" name="date" className={styles.date} />

        <CustomSelect
          className={styles.filters__select}
          options={storages.map(s => ({ value: s.id, label: s.name }))}
          value={fromStorage}
          onChange={setFromStorage}
          placeholder="Из склада"
        />

        <CustomSelect
          className={styles.filters__select}
          options={storages.map(s => ({ value: s.id, label: s.name }))}
          value={toStorage}
          onChange={setToStorage}
          placeholder="В склад"
        />

        <CustomSelect
          className={styles.filters__select}
          options={['Иван Иванов', 'Петр Петров']}
          value={''}
          onChange={() => {}}
          placeholder="Сотрудник"
        />
      </div>
      <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Номер документа</th>
            <th>Из склада</th>
            <th>В склад</th>
            <th>Комментарий</th>
            <th>Дата</th>
            <th>Статус</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            return (
              <tr 
                key={row.id} 
              >
                <td
                  onClick={() => setSelectedTransfer({ id: row.id, from: row.source_storage_id, to: row.storage_id })}
                  style={{ cursor: "pointer" }}
                >{row.name}</td>
                <td>{getStorageName(row.source_storage_id)}</td>
                <td>{getStorageName(row.storage_id)}</td>
                <td>—</td>
                <td>{new Date(row.inserted_at).toLocaleDateString()}</td>
                <td>{statusMap[row.status] || row.status}</td>
                <td className={styles.actions}>
                <button
                  onClick={(e) =>
                    openMenuId === row.id ? setOpenMenuId(null) : handleOpenMenu(e, row.id)
                  }
                  className={styles.menuBtn}
                >
                  <MoreVertical size={18} />
                </button>
                {openMenuId === row.id && (
                  <div
                    className={styles.menu}
                    ref={menuRef}
                    style={{
                      position: "absolute",
                      top: menuPosition.top,
                      left: menuPosition.left,
                    }}
                  >
                    <button onClick={() => updateStatus(row.id, "approved")}>Подтвердить</button>
                    <button onClick={() => updateStatus(row.id, "cancelled")}>Отклонить</button>
                    <button
                      onClick={() => {
                        setSelectedTransfer({
                          id: row.id,
                          from: row.source_storage_id,
                          to: row.storage_id,
                        });
                        setOpenMenuId(null);
                      }}
                    >
                      Просмотр
                    </button>
                    <button onClick={() => handleDownloadPDF(row)}>Скачать PDF</button>
                    <button onClick={() => handleDownloadXLSX(row)}>Скачать XLSX</button>
                  </div>
                )}
              </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>
      {isModalOpen && (
        <MovementModal
          onClose={() => setIsModalOpen(false)}
          onSubmit={handleModalSubmit}
        />
      )}

      {selectedTransfer && (
        <MovementSidePanel
          id={selectedTransfer.id}
          from={selectedTransfer.from}
          to={selectedTransfer.to}
          onClose={() => setSelectedTransfer(null)}
          onSuccess={() => {
            setSelectedTransfer(null); 
            fetchTransfers(); 
          }}
        />
      )}
    </div>
  );
};

export default MovementSection;
